import type { LangMap } from "./index";

export const stats: LangMap = {
  en: {
    eyebrow: "Dashboard",
    title: "Statistics",
    subtitle: "How studying is going over the last 14 days.",
    minutesStudied: "Minutes studied",
    quizzesDone: "Quizzes done",
    minutesPerDay: "Minutes / day",
    subjects: "Subjects",
    noSessionsYet: "No sessions yet.",
    quizAccuracy: "Quiz accuracy (%)",
    noQuizzesYet: "No quizzes done yet.",
    otherSubject: "Other",
  },
  it: {
    eyebrow: "Dashboard",
    title: "Statistiche",
    subtitle: "Come sta andando lo studio negli ultimi 14 giorni.",
    minutesStudied: "Minuti studiati",
    quizzesDone: "Quiz svolti",
    minutesPerDay: "Minuti / giorno",
    subjects: "Materie",
    noSessionsYet: "Nessuna sessione ancora.",
    quizAccuracy: "Accuratezza quiz (%)",
    noQuizzesYet: "Nessun quiz svolto ancora.",
    otherSubject: "Altro",
  },
  es: {
    eyebrow: "Panel",
    title: "Estadísticas",
    subtitle: "Cómo va el estudio en los últimos 14 días.",
    minutesStudied: "Minutos estudiados",
    quizzesDone: "Quiz realizados",
    minutesPerDay: "Minutos / día",
    subjects: "Materias",
    noSessionsYet: "Aún no hay sesiones.",
    quizAccuracy: "Precisión de los quiz (%)",
    noQuizzesYet: "Aún no se han hecho quiz.",
    otherSubject: "Otro",
  },
  fr: {
    eyebrow: "Tableau de bord",
    title: "Statistiques",
    subtitle: "Comment se passent tes études sur les 14 derniers jours.",
    minutesStudied: "Minutes étudiées",
    quizzesDone: "Quiz effectués",
    minutesPerDay: "Minutes / jour",
    subjects: "Matières",
    noSessionsYet: "Aucune session pour l'instant.",
    quizAccuracy: "Précision des quiz (%)",
    noQuizzesYet: "Aucun quiz effectué pour l'instant.",
    otherSubject: "Autre",
  },
  de: {
    eyebrow: "Dashboard",
    title: "Statistiken",
    subtitle: "Wie das Lernen in den letzten 14 Tagen lief.",
    minutesStudied: "Minuten gelernt",
    quizzesDone: "Quiz erledigt",
    minutesPerDay: "Minuten / Tag",
    subjects: "Fächer",
    noSessionsYet: "Noch keine Sitzungen.",
    quizAccuracy: "Quiz-Genauigkeit (%)",
    noQuizzesYet: "Noch keine Quiz erledigt.",
    otherSubject: "Sonstiges",
  },
  pt: {
    eyebrow: "Painel",
    title: "Estatísticas",
    subtitle: "Como está o estudo nos últimos 14 dias.",
    minutesStudied: "Minutos estudados",
    quizzesDone: "Quiz feitos",
    minutesPerDay: "Minutos / dia",
    subjects: "Matérias",
    noSessionsYet: "Ainda sem sessões.",
    quizAccuracy: "Precisão dos quiz (%)",
    noQuizzesYet: "Ainda nenhum quiz feito.",
    otherSubject: "Outro",
  },
};
